import "./pt-nuscale-piping-pipe-primary.css"
import FLOW_NOFLOW from "../../mixins/FLOW_NOFLOW"

export default {
    selector: "g.pt-piping-pipe-primary",
    mixins: [FLOW_NOFLOW]
}